module.exports = __webpack_public_path__ + "static/media/call-pro.488ba6e0.png";